module.exports = __webpack_public_path__ + "img/certificate-02.65ae3371.svg";